module.exports = __webpack_public_path__ + "media/images/pricing-page-pro-serv-27a4dd18.png";